import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CreditBureau from "./credit-bureau/credit-bureau-container.vue";
import Fees from "./fees/fees.vue";
import LenderResponse from "./lender-response/lender-response.vue";
import LenderSubmit from "./lender-submit/lender-submit-container.vue";
import Participants from "./participants/participants-container.vue";
import Commissions from "./commissions/commissions-container.vue";
import DirectToLenderNavigation from "../../direct-to-lender-navigation.vue";
import { debounce } from "lodash";
import { mapActions } from "vuex";
import { SAVE_CURRENT_APPLICATION } from "../../../store/application-actions";
import WidgetEventsMixin from "@Shared/utils/application-mixins/widget-events-mixin";
import Amplitude from "@Shared/utils/amplitude";
import Err from "@Broker/@Routes/error";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DirectToLenderContainer",
  title() {
    return this.$t("sidebar.sections.application.direct-to-lender");
  },
  components: {
    DirectToLenderNavigation,
    CreditBureau,
    Fees,
    LenderResponse,
    LenderSubmit,
    Commissions,
    Participants
  },
  mixins: [WidgetEventsMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentPage: "credit-bureau"
    };
  },
  computed: {
    currentPageComponent() {
      const pageParser = {
        "credit-bureau": CreditBureau,
        fees: Fees,
        commissions: Commissions,
        "lender-response": LenderResponse,
        "lender-submit": LenderSubmit,
        participants: Participants
      };
      return pageParser[this.currentPage];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SAVE_CURRENT_APPLICATION])), {}, {
    fireSave() {
      this.SAVE_CURRENT_APPLICATION({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        reFetchCalculations: true
      }).then(() => {
        this.application = this.CURRENT_APPLICATION;
        this.sendWidgetMessage("validation-rules", "refresh");
        this.sendWidgetMessage("calculation-explanations", "refresh");
      }).catch(e => {
        Amplitude.logHandledError(e, {
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
        Err.handle(e);
      });
      this.$root.$emit("update-sync-status", {
        startImmediately: true
      });
    },
    saveApplication: debounce(function () {
      this.fireSave();
    }, 300),
    handlePageChange(page) {
      if (page === "mortgage-details") {
        this.$router.push({
          name: "application",
          params: _objectSpread(_objectSpread({}, this.$route.params), {}, {
            currentTab: "mortgage-details"
          })
        });
      } else {
        this.currentPage = page;
        this.$emit("direct-to-lender-tab", page);
      }
    }
  })
});